import { Capacitor } from "@capacitor/core";

/** 移动端 App 打包（build:mobile） */
const IS_MOBILE_BUILD = process.env.VUE_APP_MOBILE_BUILD === "true";

export function shouldApplySafeAreaInsets() {
  if (typeof window === "undefined") return IS_MOBILE_BUILD;
  return IS_MOBILE_BUILD || Capacitor.isNativePlatform();
}

function readEnvInset(prop) {
  if (typeof document === "undefined") return 0;

  const probe = document.createElement("div");
  probe.style.cssText = [
    "position:fixed",
    "top:0",
    "left:0",
    "visibility:hidden",
    "pointer-events:none",
    `padding-${prop}:constant(safe-area-inset-${prop})`,
    `padding-${prop}:env(safe-area-inset-${prop})`,
  ].join(";");
  document.body.appendChild(probe);
  const key = prop === "top" ? "paddingTop" : "paddingBottom";
  const inset = parseFloat(window.getComputedStyle(probe)[key]) || 0;
  document.body.removeChild(probe);
  return inset;
}

function guessIOSInset(prop) {
  if (!Capacitor.isNativePlatform()) return 0;
  if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) return 0;
  const longSide = Math.max(window.screen.width, window.screen.height);
  if (longSide < 812) return prop === "top" ? 20 : 0;
  return prop === "top" ? 47 : 34;
}

function guessAndroidInset(prop) {
  if (!Capacitor.isNativePlatform()) return 0;
  if (!/Android/i.test(navigator.userAgent)) return 0;
  if (prop !== "top") return 0;
  const longSide = Math.max(window.screen.width, window.screen.height);
  return longSide >= 780 ? 24 : 0;
}

function syncMobileClass(enabled) {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("is-mobile-app", enabled);
}

export function applySafeAreaInsets() {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  const mobile = shouldApplySafeAreaInsets();
  syncMobileClass(mobile);

  if (!mobile) {
    root.style.setProperty("--inset-top", "0px");
    root.style.setProperty("--inset-bottom", "0px");
    return;
  }

  const top = Math.max(
    readEnvInset("top"),
    guessIOSInset("top"),
    guessAndroidInset("top")
  );
  const bottom = Math.max(
    readEnvInset("bottom"),
    guessIOSInset("bottom"),
    guessAndroidInset("bottom")
  );

  root.style.setProperty("--inset-top", `${top}px`);
  root.style.setProperty("--inset-bottom", `${bottom}px`);
}

export function initSafeAreaInsets() {
  applySafeAreaInsets();
  if (!shouldApplySafeAreaInsets()) return;
  requestAnimationFrame(applySafeAreaInsets);
  window.setTimeout(applySafeAreaInsets, 120);
  window.addEventListener("resize", applySafeAreaInsets);
  window.addEventListener("orientationchange", applySafeAreaInsets);
}
